
export function validateStatus(status: number) {
  return status === 200 || status === 204 || status === 201;
}